import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=795bc5a3&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=795bc5a3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bc5a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795bc5a3')) {
      api.createRecord('795bc5a3', component.options)
    } else {
      api.reload('795bc5a3', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=795bc5a3&scoped=true", function () {
      api.rerender('795bc5a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/system/agreement.vue"
export default component.exports